import { useSelector } from 'react-redux';
import { selectAllActiveForm, selectSpecificOrderTypeDetailsProps } from "../reducers/active-form-slice";
import { selectOrder } from '../reducers/order-details-slice';
import FileUpload from '../services/files-upload-service';
import ReportService from '../services/report-service';

export const useBuildUpdatedDraftOrder = () => {
  var order = useSelector(selectOrder);
  const allActiveFormValues = useSelector(selectAllActiveForm);
  const specificOrderTypeDetailsProps = useSelector(selectSpecificOrderTypeDetailsProps);
  const generalInfoProps = ["orderId", "glucroftAssignedId", "caseId", "orderNumber", "caseNumber", "caseName", "investigationType", "investigationTypeId", "managerAssignedId", "managerAssigned", "managerAssignedEmail", "managerAssignedEmail2", "managerAssignedPhone", "managerAssignedPhone2", "glucroftAssigned", "status", "lawFirmId", "lawFirm", "lawFirmAddress1", "lawFirmAddress2", "lawFirmCity", "lawFirmState", "lawFirmZip", "lawFirmCountry"];
  const newAttachments = useSelector(state => state.attachments);
  const currentUser = useSelector(state => state.auth.portalUser.id);

  const buildUpdatedDraftOrder = (values = null, orderSubmitted = false) => {
    const formValues = values || allActiveFormValues;

    var generalDetails = Object.keys(order.details)
      .filter(key => generalInfoProps.includes(key))
      .reduce((obj, key) => {
        obj[key] = key == 'status' && orderSubmitted ? 'New' : order.details[key];
        return obj;
      }, {});

    var updatedSpecificOrderTypeDetails = Object.keys(formValues)
      .filter(key => specificOrderTypeDetailsProps.includes(key))
      .reduce((obj, key) => {
        obj[key] = formValues[key];
        return obj;
      }, {});

    updatedSpecificOrderTypeDetails = Object.entries(updatedSpecificOrderTypeDetails)
      .reduce((acc, [key, value]) => {
        if (typeof value === 'object') {
          return {
            ...acc, ...Object.entries(value).reduce((innerAcc, [innerKey, innerValue]) => {
              if (innerKey.includes('time') && innerValue) {
                var timeValue = new Date(innerValue).toLocaleTimeString([], { hour: "numeric", minute: "numeric", hour12: true });
                return { ...innerAcc, [innerKey]: timeValue };
              }
              return { ...innerAcc, [innerKey]: innerValue };
            }, {})
          };
        } else {
          return { ...acc, [key]: value };
        }
      }, {});

    const specificOrderTypeDetails = JSON.stringify(updatedSpecificOrderTypeDetails);

    if (orderSubmitted && values) {
      generateSummaryReport(formValues);
    }

    const updatedOrder = {
      ...generalDetails,
      specificOrderTypeDetails
    };

    const newOrderObject = JSON.parse(JSON.stringify(order));
    newOrderObject.details = updatedOrder;

    return { values: {}, order: newOrderObject };
  };


  const uploadAttachments = async () => {
    var specificAttachments = newAttachments.intakeAttachments_specific.slice();
    var additionalAttachments = newAttachments.intakeAttachments_additional.slice();
    var attachments = [...specificAttachments, ...additionalAttachments];

    if (attachments.length > 0) {
      await FileUpload.Upload(attachments, order.id, currentUser);
    }
  };


  const generateSummaryReport = async (formValues) => {
    if ((formValues.investigationType[0].includes("Insurance Investigation")) || (formValues.investigationType[0].includes("Insurance Claim History"))) {
      await ReportService.GenerateSummaryReport(order.id, "true", "false");
    }
  };

  return { buildUpdatedDraftOrder, uploadAttachments };
}


